import { render, staticRenderFns } from "./agreementDetails.vue?vue&type=template&id=2b0e7658"
import script from "./agreementDetails.ts?vue&type=script&lang=js&external"
export * from "./agreementDetails.ts?vue&type=script&lang=js&external"
import style0 from "./agreementDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports